export type JobApplicationStatus =
  | "applied"
  | "shortlisted"
  | "interview"
  | "rejected"
  | "accepted"
  | "hired";

export type ProfileMatchStatus = {
  status: "unqualified" | "qualified" | "pending";
  score: number;
};

export type QuestionnaireStatus =
  | "pending"
  | "qualified"
  | "unqualified"
  | "partially_qualified"
  | "action_required";

export type uploadType = "company" | "candidate" | "lever" | "zoho" | "custom";

export interface JobApplicationUser {
  _id: string;
  firstName: string;
  lastName: string;
  email?: string;
  phone?: string;
}

export interface JobApplicationJobPost {
  _id: string;
  title: string;
}

export type RejectionReason =
  | "marked_by_recruiter"
  | "profile_match_failure"
  | "ai_assessment_failure"
  | "ai_assessment_violation";

export const RejectionReasonLabels: Record<RejectionReason, string> = {
  marked_by_recruiter: "Rejected by recruiter",
  profile_match_failure: "Profile did not meet requirements",
  ai_assessment_failure: "Did not clear AI assessment",
  ai_assessment_violation: "Assessment integrity violation",
};

export const getRejectionReasonLabel = (
  reason: RejectionReason | null,
): string | null => {
  if (!reason) return null;
  return RejectionReasonLabels[reason];
};

export interface JobApplication {
  _id: string;
  user: JobApplicationUser;
  jobPost: JobApplicationJobPost;
  profileId?: string;
  applied_date: string;
  status: JobApplicationStatus;
  comments?: string;
  orgId: string;
  createdAt: Date;
  updatedAt: Date;
  profileMatchStatus?: ProfileMatchStatus;
  questionnaireStatus?: QuestionnaireStatus;
  interviewSchedule?: string;
  uploadType: uploadType;
  appId: string | null;
  rejectionReason: RejectionReason | null;
}
